import '../src/js/email-suggestion';
import validateEmail from '../src/js/email-validation';

document.addEventListener('DOMContentLoaded', () => {
  validateEmail();
});
